import { createContext } from 'react';
import { UserSettings } from 'src/types/UserSettings';
import { defaultUserSettings } from 'src/bootstrap/constants';
import { Filter, FilterConfig } from 'src/utils/composeFilter.ts';
import { GetComparator } from 'src/common/types/Comparator.ts';

export type ConfigContextProps = {
    uri: string;
    imageProxyUri: string;
    userSettings: UserSettings;
    mandatoryFilterConfig: {
        config: FilterConfig;
        values: Filter;
    };
    rootElement: Element;
    numberFormat: {
        thousandSeparator: string;
        decimalSeparator: string;
    };
    currency: string | null;
    getComparator: GetComparator;
    gaPush: (event: unknown) => void;
}

export const ConfigContext = createContext<ConfigContextProps>(
    {
        gaPush: () => null,
        getComparator: () => () => 0,
        imageProxyUri: '',
        uri: '',
        userSettings: defaultUserSettings,
        mandatoryFilterConfig: {
            config: [],
            values: {},
        },
        rootElement: document.createElement('div'),
        numberFormat: {
            thousandSeparator: ',',
            decimalSeparator: '.',
        },
        currency: null,
    },
);
